import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    SendAddToWishListEvent,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    buildGA4ItemFromProduct,
    getCurrencyCode,
    trackGA4AddToWishList,
} from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const SendGA4AddToWishListEvent: typeof SendAddToWishListEvent = props => {
    if (!props.result.wishList) {
        return;
    }

    const state = props.getState();
    const currency = getCurrencyCode(state);
    let totalValue = 0;

    const items = props.parameter.productInfos
        .map(productInfo => {
            const productState = getProductState(state, productInfo.productId);
            if (!productState.value) {
                return null;
            }
            const product = productState.value;
            totalValue += (product.unitListPrice || 0) * (productInfo.qtyOrdered || 1);
            return buildGA4ItemFromProduct(product, { quantity: productInfo.qtyOrdered });
        })
        .filter((item): item is NonNullable<typeof item> => item !== null);

    if (items.length > 0) {
        trackGA4AddToWishList(items, currency, totalValue);
    }
};

addToChainAfter(chain, SendAddToWishListEvent, SendGA4AddToWishListEvent);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
